var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26029 3.25066C3.30199 2.91704 3.58559 2.66669 3.92182 2.66669H12.0781C12.4143 2.66669 12.6979 2.91704 12.7396 3.25066L13.9063 12.584C13.956 12.9819 13.6458 13.3334 13.2448 13.3334H2.75514C2.35414 13.3334 2.04389 12.9819 2.09363 12.584L3.26029 3.25066Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6C5 6 5.66667 7.33333 8 7.33333C10.3333 7.33333 11 6 11 6",
    stroke: "#7A7A7A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.943cf7714147fbc6a099ce71221979f1.svg";
export { ForwardRef as ReactComponent };